module.exports = __webpack_public_path__ + "static/media/smiley-face-city.2d30e218.svg";